import React, { Component } from 'react';
import Server from '../../common/server';
import './index.scss';
// 头部下载
import DownLoadDict from './downLoadDict.js'
// 文章内容部分
import ArticleContact from './articleContact.js'
// 音频控制
import AudioControl from './audioControl.js'
import utils from '../../common/utils';

class audioArticleShare extends Component {
  constructor(props, context){
    super(props)
    this.state = {
      articleContact: [],
      audioParagraphIndex: '',
      audioSrc: '',
      audioDuration: '',
      vip: '',
      languageStatus: '',
      hasTrans: '',
      title: '',
      articlelanguage: '',
      articleStatus: [
        'http://ydschool-online.nos.netease.com/1572863708907ic_audio_article_control_language_both%402x.png', // 双语
        'http://ydschool-online.nos.netease.com/1572863752330ic_audio_article_control_language_source%402x.png', // 原文
        'http://ydschool-online.nos.netease.com/1572863734551ic_audio_article_control_language_translation%402x.png', //译文
        'http://ydschool-online.nos.netease.com/1572863764657ic_audio_article_control_language_hidden%402x.png' // 隐藏
      ]
    }
  }
  componentDidMount(){
    var me = this
    let id = this.props.match.params.id
    Server.getArticleContact(id, function (json) {
      let articleContact
      if (json.data.vip) {
        articleContact = json.data.encryptSyncContent
      } else {
        articleContact = JSON.parse(utils.Decrypt(json.data.encryptSyncContent))
      }
      // var ua = navigator.userAgent.toLowerCase();
      // // 处理QQ浏览器无法动态设置标题的bug
      // if (ydk.isIos && ua.match(/QQ/i) === "qq") {
      //   alert('qq')
      //   let i = document.createElement('iframe');
      //   i.src = 'https://www.baidu.com/favicon.ico';
      //   i.style.display = 'none';
      //   i.onload = function () {
      //     setTimeout(function () {
      //       i.remove();
      //     }, 9)
      //   }
      //   document.title = 'json.data.title';
      //   document.body.appendChild(i);
      // } else {
        document.title = json.data.title
      // }
      // 设置QQ分享内容
      document.getElementsByTagName('meta')['qq-share-title'].content = json.data.title
      document.getElementsByTagName('meta')['qq-share-desc'].content = json.data.columnTitle;
      document.getElementsByTagName('meta')['qq-share-image'].content = json.data.imgUrl
      me.setState({
        articleContact: articleContact,
        title: json.data.title,
        vip: json.data.vip,
        audioSrc: json.data.audioUrl,
        audioDuration: json.data.audioDuration,
        hasTrans: json.data.switchBtn.hasTrans
      })
      window.ydk.share({
        silence: true,
        shift: true,
        title: json.data.title,
        desc: json.data.columnTitle,
        imgUrl: json.data.imgUrl,
        link: window.location.href
      })
      // 当this.props.hasTrans === true 时，代表当前文章含有译文，所以默认是双语
    // 如果不含有译文默认是原文
      let hasTrans = json.data.switchBtn.hasTrans
      if (json.data.vip) {
        me.setState({
          articlelanguage: me.state.articleStatus[3]
        })
      } else {
        if (hasTrans) {
          me.setState({
            articlelanguage: me.state.articleStatus[0]
          })
        } else {
          me.setState({
            articlelanguage: me.state.articleStatus[1]
          })
        }
      }
    })
  }
  render() {
    return (
      <div className="audio_article_share">
        <DownLoadDict />
        <ArticleContact vip={this.state.vip} audioParagraphIndex={this.state.audioParagraphIndex} articleContact={this.state.articleContact} contralAudioTime={this.contralAudioTime.bind(this)} title={this.state.title} languageStatus={this.state.languageStatus} changelanguageStatus={this.changelanguageStatus.bind(this)}/>
        <AudioControl ref="audioControl" vip={this.state.vip} changeParagraphhighlight={this.changeParagraphhighlight.bind(this)} articleContact={this.state.articleContact} articlelanguageChange={this.articlelanguageChange.bind(this)} audioSrc={this.state.audioSrc} hasTrans={this.state.hasTrans} audioDuration={this.state.audioDuration} articlelanguage={this.state.articlelanguage} articleStatus={this.state.articleStatus} changeArticleLanguage={this.changeArticleLanguage.bind(this)}/>
      </div>
    );
  }
  changeArticleLanguage () {
    if (this.state.vip) {
      this.setState({
        articlelanguage: this.state.articleStatus[3]
      })
      return
    }
    let index = 0
    for (let i = 0; i < this.state.articleStatus.length; i++) {
      if (this.state.articlelanguage === this.state.articleStatus[i]) {
        if ((i + 1) === this.state.articleStatus.length || i === 1) {
          // 查看是否含有翻译
          if (this.state.hasTrans) {
            if ((i + 1) === this.state.articleStatus.length) {
              index = 0
            } else {
              index = i + 1
            }
          } else {
            if (i === 1) {
              index = 3
            } else {
              index = 1
            }
          }
        } else {
          index = i + 1
        }
        break;
      }
    }
    this.articlelanguageChange(index)
    this.setState({
      articlelanguage: this.state.articleStatus[index]
    })
  }
  changelanguageStatus() {
    this.changeArticleLanguage()
  }
  contralAudioTime(startTs, index) {
    this.refs.audioControl.rePlay(startTs)
    this.setState({
      audioParagraphIndex: index
    })
  }
  changeParagraphhighlight(index) {
    this.setState({
      audioParagraphIndex: index
    })
  }
  articlelanguageChange(index) {
    // index= 0(双语), 1(原文), 2(译文), 3(隐藏)
    this.setState({
      languageStatus: index
    })
  }
}

export default audioArticleShare;
